import { Box, Container, Typography, Divider } from '@mui/material';
import logo from '../assets/images/logo.png';
import simandouguinea2 from '../assets/images/simandouguinea2.png';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        background: '#ffffff',
        color: '#1a1a1a',
        position: 'relative',
        overflow: 'hidden',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0, left: 0, right: 0,
          height: 3,
          background: 'linear-gradient(90deg, #d21433, #ffc71f, #007481, #d21433)',
          backgroundSize: '200% 100%',
          animation: 'shimmerBorder 3s linear infinite',
        },
        '@keyframes shimmerBorder': {
          '0%': { backgroundPosition: '0% 0%' },
          '100%': { backgroundPosition: '200% 0%' },
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: { xs: 2.5, md: 3 },
            gap: 2,
            flexWrap: { xs: 'wrap', md: 'nowrap' },
          }}
        >
          {/* Logo ANDE (gauche) */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flex: '0 0 auto',
              transition: 'transform 0.3s ease',
              '&:hover': { transform: 'scale(1.04)' },
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Logo ANDE"
              sx={{
                height: { xs: 44, md: 54 },
                width: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Texte central */}
          <Box sx={{ textAlign: 'center', flex: 1, minWidth: 0 }}>
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                letterSpacing: 2,
                textTransform: 'uppercase',
                color: '#666',
                mb: 0.5,
                fontSize: '0.65rem',
              }}
            >
              Application développée par
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 800,
                fontSize: { xs: '0.95rem', md: '1.05rem' },
                letterSpacing: 0.5,
                lineHeight: 1.3,
                color: '#007481',
              }}
            >
              ANDE — Agence Nationale de Digitalisation de l'État
            </Typography>
            <Divider sx={{ my: 1, borderColor: 'rgba(0,0,0,0.1)' }} />
            <Typography
              variant="caption"
              sx={{ color: '#888', fontSize: '0.7rem', letterSpacing: 0.3 }}
            >
              © {year} Tous droits réservés · République de Guinée
            </Typography>
          </Box>

          {/* Image Simandou Guinée (droite) */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flex: '0 0 auto',
              transition: 'transform 0.3s ease',
              '&:hover': { transform: 'scale(1.04)' },
            }}
          >
            <Box
              component="img"
              src={simandouguinea2}
              alt="Simandou Guinea"
              sx={{
                height: { xs: 52, md: 64 },
                width: 'auto',
                objectFit: 'contain',
                filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.15))',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
